// Mirrors Contract.VOID_REASON_CODE_CHOICES' user-selectable codes and labels
// exactly; revoking with anything else is a 400.
export const REASON_CODES = [
  { value: "fee_changed", label: "Fee changed" },
  {
    value: "inspection_date_or_address_changed",
    label: "Inspection date or address changed",
  },
  { value: "client_information_changed", label: "Client information changed" },
  { value: "inspection_cancelled", label: "Inspection cancelled" },
  { value: "sent_in_error", label: "Sent in error" },
  { value: "other", label: "Other" },
];

const LABEL_BY_CODE = Object.fromEntries(
  REASON_CODES.map((reason) => [reason.value, reason.label])
);

export const revokeReasonText = (contract) => {
  const code = contract?.void_reason_code;
  const note = contract?.void_reason;
  if (code === "other" && note) return note;
  return LABEL_BY_CODE[code] || note || "Contract revoked";
};
